/* eslint-disable no-case-declarations */
import React, { createContext, useReducer, useContext, useEffect } from 'react';

const initialState = {
  state: {},
  data: {},
  session:{
    requestDone:false
  },
  answers: [],
  questionsValid: [],
  userContactData: [], 
  userData: {
    telefono: '',
    comentario: '',
    mail: '',
    is_first_visit: undefined,
    referral: undefined,
  },
  ui: {
    startIndex: 0,
    currentView:'question',
    isDark:false,
  },
}

const immute = (root, merge = true, path, payload) => {
  const steps = (path || '').split('.');

  const immuted = steps.reduce(({ parent, root }, step, index) => {
    const lastStep = index === steps.length - 1;

    if (lastStep) {
      parent[step] = merge ? {
        ...(parent[step] || {}),
        ...payload,
      } : payload;
    } else {
      parent[step] = {
        ...(parent[step] || {}),
      };
    }
    if (parent[step] === undefined) delete parent[step];
    return lastStep ? (root || parent) : {
      parent: parent[step],
      root: root || parent,
    }
  }, {
    parent: {
      ...root
    },
  });
  return immuted;
}

export const store = createContext(initialState);

export const useStoreContext = () => useContext(store);

export const StoreProvider = ({ storeRef, children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'update':
        return immute(state, true, action.path, action.payload);
      case 'data.update':
        return immute(state, true, 'data', action.payload);
      case 'session.update':
        return immute(state, true, 'session', action.payload);
      case 'answers.update':
        return {
          ...state,
          answers: [
            ...action.payload,
          ],
        };
      case 'answers.clear':
        return {
          ...state,
          answers: [
            ...initialState.answers,
          ],
        };
      case 'questionsValid.update':
        return {
          ...state,
          questionsValid: [
            ...action.payload,
          ],
        };
      case 'ui.update':
        return {
          ...state,
          ui: {
            ...state.ui,
            ...action.payload,
          },
        };
      case 'ui.clear':
        return {
          ...state,
          ui: {
            ...state.ui,
            startIndex:0,
          },
        };
      case 'userData.update':
        return {
          ...state,
          userData: {
            ...state.userData,
            ...action.payload,
          },
        };
      case 'userContactData.update':
        return {
          ...state,
          userContactData: [
            ...action.payload,
          ],
        };
      case 'userContactData.setResponse':
        const fieldName = action.payload.fieldName;
        const value = action.payload.value;

        const index = state.userContactData.findIndex((filter) => filter.name === fieldName);
        state.userContactData[index] = { ...state.userContactData[index], response: value };

        return {
          ...state,
          userContactData: [
            ...state.userContactData,
          ],
        };
      case 'userContactData.clear':
        return {
          ...state,
          userContactData: [
            ...initialState.userContactData,
          ],
        };

      default:
        throw new Error();
    };
  }, initialState);

  useEffect(() => {
    if (!storeRef) return;
    storeRef.current = {
      state,
      dispatch,
    };
  }, [state, dispatch, storeRef]);

  return <store.Provider value={{ context: state, dispatch }}>{children}</store.Provider>;
}
